import React from 'react';

const Circle = ({ label, isActive, isAddOn, onClick, style, baseColor, activeColor }) => {
  const combinedStyle = {
    ...style,
    '--base-color': baseColor || '#d0d0d0',
    '--active-color': activeColor || '#ffffff',
    '--addon-border-color': activeColor || '#ffffff'
  };

  return (
    <div
      className={`circle ${isActive ? 'active' : ''} ${isAddOn ? 'addon-active' : ''}`}
      onClick={onClick}
      style={combinedStyle}
    >
      <span className="label">{label}</span>
    </div>
  );
};

export default Circle;